import { useQuery } from "@tanstack/react-query"
import { fetchMedia } from "../api/media";

export const useGetAllMedia = () => {
    return useQuery({
        queryKey: ['all-media'],
        queryFn: fetchMedia,
    });
}